import { render } from "./SearchIcon.vue?vue&type=template&id=180adbbd&scoped=true"
import script from "./SearchIcon.vue?vue&type=script&lang=js"
export * from "./SearchIcon.vue?vue&type=script&lang=js"

import "./SearchIcon.vue?vue&type=style&index=0&id=180adbbd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180adbbd"]])

export default __exports__